
export default function prepareCart(cart) {
  const newCart = [];
  cart.forEach((item) => {
    let newItem = {};
    if (item.type !== 'guidedTour') {
      Object.assign(newItem, item);
    }
    if (item.type === 'guidedTour') {
      newItem = {};
      newItem.type = 'guidedTour';
      newItem.answers = item.answers;
      newItem.datetime = `${item.date} ${item.time}:00`;
      newItem.tourId = item.tourId;

      newItem.prices = [];

      item.tours.forEach((t) => {
        const price = {
          id: t.id,
          count: t.count,
        };
        newItem.prices.push(price);
      });
      newItem.tickets = [];
      item.tickets.forEach((ticket) => {
        const newTicket = {
          id: ticket.id,
          count: ticket.count,
        };
        if (typeof ticket.subtickets !== 'undefined') {
          newTicket.subtickets = [];
          ticket.subtickets.forEach((subticket) => {
            newTicket.subtickets.push({
              id: subticket.id,
              count: subticket.count,
            });
          });
        }
        newItem.tickets.push(newTicket);
      });
      newCart.push(newItem);
    } else if (item.type === 'ticket') {
      const t = {
        type: 'ticket',
        count: newItem.totalCount,
        id: newItem.id,
        datetime: newItem.datetime,
      };
      if (typeof newItem.subtickets !== 'undefined') {
        t.subtickets = [];
        newItem.subtickets.forEach((st) => {
          t.subtickets.push({
            id: parseInt(st.id, 10),
            count: st.count,
          });
        });
      }
      newCart.push(t);
    } else if (item.type === 'voucherCode') {
      const v = {
        type: 'voucherCode',
        barcode: newItem.barcode,
      };
      newCart.push(v);
    } else {
      newCart.push(newItem);
    }
  });
  return newCart;
}
